<template>
	<ul class="flex flex-col gap-2 w-full">
		<li
			v-for="item in services"
			:key="item.id"
			class="grid grid-cols-2 gap-4"
		>
			<span>{{ item.name }}</span>
			<span class="text-right">
				{{ formatOpeningHours(item.from, item.to) }}
			</span>
		</li>
	</ul>
</template>

<script setup lang="ts">
	import type {PageTypeRestaurantStoryblok} from '@/storyblok/types';

	type Props = {
		services: PageTypeRestaurantStoryblok['specificRestaurantServices'];
	};

	defineProps<Props>();

	function formatOpeningHours(from?: string, to?: string): string {
		return (from && to) ? `${from} - ${to}` : from ? `Od ${from}` : to ? `Do ${to}` : '';
	}
</script>
